import React from "react";
import { NavLink, Link } from "react-router-dom";
import Meta from "../components/Meta";

function NotFoundPage() {
  return (
    <>
      <Meta title="Page not found" />
      <section className="dark flex items-center justify-center h-screen bg-background px-6 py-12 font-jakarta text-foreground">
        <div className="w-full max-w-2xl text-center bg-card border border-border rounded-2xl p-10 md:p-14 shadow-lg">
          <h2 className="text-2xl md:text-3xl font-bold tracking-tight">
            <Link to="/">
              Sound Commerce<span className="text-brand">.</span>
            </Link>
          </h2>

          {/* GIF block */}
          <div className="my-8 flex justify-center">
            <img
              src="/images/pirates/disinclined.gif"
              alt="Disinclined Pirate"
              className="rounded-lg max-h-80 object-contain"
            />
          </div>

          <h1 className="text-4xl md:text-5xl font-bold text-foreground my-4">
            404 – Page not found
          </h1>
          <p className="text-muted-foreground mb-8 text-base">
            Sorry, we couldn’t find the page you’re looking for.
          </p>

          <NavLink
            to="/"
            className="inline-block w-full rounded-md border border-brand bg-background text-foreground px-4 py-3 text-base font-medium hover:border-brand hover:text-brand transition focus:outline-none focus:ring-2 focus:ring-brand focus:ring-offset-2"
          >
            Go back home
          </NavLink>
        </div>
      </section>
    </>
  );
}

export default NotFoundPage;
